import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var RadioIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12,3.07A8.93,8.93,0,1,0,20.93,12,8.93,8.93,0,0,0,12,3.07Zm-.05,13a4,4,0,1,1,4-4A4,4,0,0,1,12,16.05Z"
}), 'RadioIcon');